import {DatabaseConnection} from '@vizir-banking/banking-app-core/dist/utils/db/db-connection';
import {NullDatabaseConnection} from '@vizir-banking/banking-app-core/dist/utils/db/null-db-connection';

export const databaseAdapter: DatabaseConnection = new NullDatabaseConnection();
